import { Validators } from '@angular/forms';
import { UtilsService } from 'src/app/services/utils.service';

export class FormularioCondominio {

  public static utils = UtilsService

  public static get segurado() {
    return {
      cpfCnpj: {
        title: 'CNPJ',
        type: 'text',
        formControlName: 'cpfCnpj',
        valueDefault: null,
        validators: [
          Validators.required,
          Validators.pattern('[0-9]{2}.[0-9]{3}.[0-9]{3}/[0-9]{4}-[0-9]{2}'),
          this.utils.formBuilderCpfCnpjCustomForm()
        ],
        mask: null,
        matError: {
          enabled: true,
          errosConfig: [
            {
              hasError: 'required',
              message: 'Insira um CNPJ.'
            },
            {
              hasError: 'pattern',
              message: 'CNPJ Inválido.'
            }
          ]
        },
        functions: null,
        placeholder: 'Ex. 00.000.000/0000-00',
        class: 'inputs-form fonts-sizes col-xl-3 hasloader',
        matSpinner: {
          enabled: false,
          diameter: 20
        }
      },
      nome: {
        title: 'Razão Social',
        type: 'text',
        formControlName: 'nome',
        valueDefault: null,
        validators: [
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(100),
          Validators.pattern('[A-Za-z0-9áàâãäéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ.-\/&]+\\s+[A-Za-z0-9áàâãäéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ.-\/&\\s]{3,100}')
        ],
        mask: null,
        matError: {
          enabled: true,
          errosConfig: [
            {
              hasError: 'required',
              message: 'Razão social Inválida.'
            },
            {
              hasError: 'pattern',
              message: 'Razão social Inválida.'
            },
            {
              hasError: 'maxlength',
              message: 'A razão social deve ter no máximo 100 caracteres.'
            }
          ]
        },
        class: 'inputs-form fonts-sizes col-xl-9',
      },
      fone1: {
        title: 'Telefone',
        type: 'text',
        formControlName: 'fone1',
        valueDefault: null,
        validators: [
          Validators.required,
          Validators.pattern('\\([0-9]{2}\\)\\s[0-9]{4,5}-[0-9]{4}'),
        ],
        functions: {
          clickMatIconExec: null,
          ngModelChangeExec: null
        },
        matError: {
          enabled: true,
          errosConfig: [
            {
              hasError: 'required',
              message: 'Insira um Telefone.'
            },
            {
              hasError: 'pattern',
              message: 'Telefone Inválido.'
            }
          ]
        },
        isMatIcon: true,
        mask: null,
        placeholder: 'Ex. (00) 0000-0000',
        class: 'inputs-form fone-icone inputs-icones-condominio fonts-sizes col-xl-3',
      },
      email: {
        title: 'Email',
        type: 'email',
        formControlName: 'email',
        valueDefault: null,
        validators: Validators.email,
        mask: null,
        functions: {
          clickMatIconExec: null,
        },
        isMatIcon: true,
        placeholder: 'Ex. pat@example.com',
        class: 'inputs-form email-icone inputs-icones-condominio fonts-sizes col-xl-9',
      },
      tipoPessoa: {
        title: '',
        type: 'text',
        formControlName: 'tipoPessoa',
        valueDefault: 'J',
        validators: null,
        mask: null,
        functions: null,
        class: 'col-xl-1 d-none',
      },
      buttonSubmit: {
        title: 'SUBMIT',
        type: 'button',
        formControlName: 'buttonSubmit',
        valueDefault: 'J',
        validators: null,
        mask: null,
        functions: null,
        class: 'd-none',
        id: 'button-submit-segurado'
      }
    };
  }

  public static get coberturas() {
    return {
      isDanosIncendioRaioExplosao: {
        title: 'Incêndio/raio/explosão',
        type: 'mat-select',
        formControlName: 'isDanosIncendioRaioExplosao',
        options: null,
        valueDefault: null,
        validators: [Validators.required],
        mask: null,
        matError: {
          enabled: true,
          errosConfig: [
            {
              hasError: 'required',
              message: 'Selecione uma opção.'
            }
          ]
        },
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      isDanosIncendioRaioExplosaoCond: {
        title: 'Incêndio de conteúdo (condôminos)',
        type: 'mat-select',
        formControlName: 'isDanosIncendioRaioExplosaoCond',
        options: null,
        valueDefault: null,
        validators: null,
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      isValorCondominio: {
        title: 'RC Condominio',
        type: 'mat-select',
        formControlName: 'isValorCondominio',
        valueDefault: null,
        validators: Validators.required,
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      isValorSindico: {
        title: 'RC Síndico',
        type: 'mat-select',
        formControlName: 'isValorSindico',
        valueDefault: null,
        validators: Validators.required,
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      isDanosEletricos: {
        title: 'Danos elétricos',
        type: 'mat-select',
        formControlName: 'isDanosEletricos',
        options: null,
        valueDefault: null,
        validators: [Validators.required],
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      isDanosImpactoVeiculo: {
        title: 'Vendaval/ Imp. veículos',
        type: 'mat-select',
        formControlName: 'isDanosImpactoVeiculo',
        options: null,
        valueDefault: null,
        validators: [Validators.required],
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      isDanosRoubo: {
        title: 'Roubo de bens (condominio)',
        type: 'mat-select',
        formControlName: 'isDanosRoubo',
        options: null,
        valueDefault: null,
        validators: [Validators.required],
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      isDanosPortoes: {
        title: 'Portões',
        type: 'mat-select',
        formControlName: 'isDanosPortoes',
        options: null,
        valueDefault: null,
        validators: null,
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      isDanosMorais: {
        title: 'Danos Morais',
        type: 'mat-select',
        formControlName: 'isDanosMorais',
        valueDefault: null,
        validators: null,
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      vidros: {
        title: 'Vidros',
        type: 'mat-select',
        formControlName: 'vidros',
        options: null,
        valueDefault: null,
        validators: [Validators.required],
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      isDanosDesmoronamento: {
        title: 'Desmoronamento',
        type: 'mat-select',
        formControlName: 'isDanosDesmoronamento',
        options: null,
        valueDefault: null,
        validators: null,
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      isDanosAluguel: {
        title: 'Perda/pagto aluguel (condômino)',
        type: 'mat-select',
        formControlName: 'isDanosAluguel',
        options: null,
        valueDefault: null,
        validators: [Validators.required],
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      isDanosVazamentoTanquesTubulacoes: {
        title: 'Vazamento de tanques e tubulações',
        type: 'mat-select',
        formControlName: 'isDanosVazamentoTanquesTubulacoes',
        options: null,
        valueDefault: null,
        validators: [Validators.required],
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      assist24hs: {
        title: 'Assistência 24hs',
        type: 'mat-select',
        formControlName: 'assist24hs',
        options: null,
        valueDefault: 1,
        validators: Validators.required,
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      tpGuardaTerceirizada: {
        title: 'Tipo Guarda Veic. 3ª',
        type: 'mat-select',
        formControlName: 'tpGuardaTerceirizada',
        options: null,
        valueDefault: 0,
        validators: null,
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      valGuardaTerceirizada: {
        title: 'RC - Guarda veículo 3ª',
        type: 'mat-select',
        formControlName: 'valGuardaTerceirizada',
        valueDefault: null,
        validators: [Validators.required],
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      vidaGrupo: {
        title: 'Vida em Grupo',
        type: 'mat-select',
        formControlName: 'vidaGrupo',
        options: null,
        valueDefault: 0,
        validators: Validators.required,
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      valorVidaGrupo: {
        title: 'Valor Vida em Grupo',
        type: 'mat-select',
        formControlName: 'valorVidaGrupo',
        options: null,
        valueDefault: null,
        validators: [Validators.required],
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      qtdVidaGrupo: {
        title: 'Qtd.de vidas',
        type: 'mat-select',
        options: null,
        formControlName: 'qtdVidaGrupo',
        valueDefault: null,
        validators: [Validators.required],
        mask: null,
        class: 'inputs-form fonts-sizes  col-xl-2',
      },
      buttonSubmit: {
        title: 'SUBMIT',
        type: 'button',
        formControlName: 'buttonSubmit',
        valueDefault: 'J',
        validators: null,
        mask: null,
        functions: null,
        class: 'd-none',
        id: 'button-submit-coberturas'
      }
    };
  }

  public static get renovacao() {
    return {
      renovacao: {
        title: 'Renovacao',
        type: 'checkbox',
        formControlName: 'renovacao',
        options: null,
        valueDefault: false,
        validators: null,
        mask: null,
        class: 'inputs-form fonts-sizes col-12 checkboxForm',
      },
      vigIniAnterior: {
        title: 'Início Vigência Anterior',
        type: 'text',
        formControlName: 'vigIniAnterior',
        valueDefault: '',
        validators: [Validators.required, Validators.pattern(
          '([0-2][0-9]|3[0-1])/(0[0-9]|1[0-2])/[0-9]{4}'
        )],
         matError: {
          enabled: true,
          errosConfig: [
            {
              hasError: 'required',
              message: 'Insira uma data.'
            },
            {
              hasError: 'pattern',
              message: 'Data Inválida.'
            }
          ]
        },
        mask: null,
        
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      vigFimAnterior: {
        title: 'Final Vigência Anterior',
        type: 'text',
        formControlName: 'vigFimAnterior',
        valueDefault: '',
        validators: [Validators.required, Validators.pattern(
          '([0-2][0-9]|3[0-1])/(0[0-9]|1[0-2])/[0-9]{4}'
        )],
        mask: null,
        matError: {
          enabled: true,
          errosConfig: [
            {
              hasError: 'required',
              message: 'Insira uma data.'
            },
            {
              hasError: 'pattern',
              message: 'Data Inválida.'
            }
          ]
        },
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      seguradoraAnteriorId: {
        title: 'Seguradora Anterior',
        type: 'mat-select',
        options: null,
        formControlName: 'seguradoraAnteriorId',
        valueDefault: '',
        validators: [Validators.required],
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-6',
      },
      numeroRenovacao: {
        title: 'Número apólice anterior',
        type: 'text',
        formControlName: 'numeroRenovacao',
        valueDefault: '',
        validators: [Validators.required],
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      codigoInterno: {
        title: 'Código interno (CI)',
        type: 'text',
        formControlName: 'codigoInterno',
        valueDefault: null,
        validators: null,
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3 d-none',
      },
      sinistrosAnterior: {
        title: 'Quantidade de sinistros',
        type: 'mat-select',
        formControlName: 'sinistrosAnterior',
        options: null,
        valueDefault: 0,
        validators: [Validators.required],
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      bonusAnterior: {
        title: 'Bônus de Renovação',
        type: 'mat-select',
        formControlName: 'bonusAnterior',
        options: null,
        valueDefault: 0,
        validators: [Validators.required],
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      buttonSubmit: {
        title: 'SUBMIT',
        type: 'button',
        formControlName: 'buttonSubmit',
        valueDefault: 'J',
        validators: null,
        mask: null,
        functions: null,
        class: 'd-none',
        id: 'button-submit-renovacao'
      }
    };

  }

  public static get seguro() {
    return {
      vigenciaIni: {
        title: 'Início Vigência',
        type: 'text',
        formControlName: 'vigenciaIni',
        valueDefault: null,
        validators: [
          Validators.required,
          Validators.pattern('([0-2][0-9]|3[0-1])/(0[0-9]|1[0-2])/[0-9]{4}'),
          FormularioCondominio.utils.validarDataCustomForm(),
          FormularioCondominio.utils.validarDataMaximaVigenciaCustom()
        ],
        mask: null,
        matError: {
          enabled: true,
          errosConfig: [
            {
              hasError: 'required',
              message: 'Digite uma data.'
            },
            {
              hasError:'validarDataCustomForm',
              message: 'Data Inválida'
            }
          ]
        },
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      vigenciaFim: {
        title: 'Final Vigência',
        type: 'text',
        formControlName: 'vigenciaFim',
        valueDefault: null,
        validators: [
          Validators.required,
          Validators.pattern('([0-2][0-9]|3[0-1])/(0[0-9]|1[0-2])/[0-9]{4}'),
          FormularioCondominio.utils.validarDataCustomForm(),
          FormularioCondominio.utils.validarDataMaximaVigenciaCustom()
        ],
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      // origem: {
      //   title: '',
      //   type: 'text',
      //   formControlName: 'origem',
      //   validators: Validators.required,
      //   mask: null,
      //   class: 'none col-xl-1 d-none',
      // },
      integracaoID: {
        title: '',
        type: 'text',
        formControlName: 'integracaoID',
        valueDefault: null,
        validators: null,
        mask: null,
        class: 'none col-xl-1 d-none',
      },
      tipoSeguro: {
        title: '',
        type: 'text',
        formControlName: 'tipoSeguro',
        valueDefault: 1,
        validators: null,
        mask: null,
        class: 'none col-xl-1 d-none',
      },
      buttonSubmit: {
        title: 'SUBMIT',
        type: 'button',
        formControlName: 'buttonSubmit',
        valueDefault: 'J',
        validators: null,
        mask: null,
        functions: null,
        class: 'd-none',
        id: 'button-submit-seguro'
      }
    };
  }

  public static get configuracoes() {
    return {
      imovelCep: {
        title: 'CEP',
        type: 'text',
        formControlName: 'imovelCep',
        valueDefault: null,
        validators: [
          Validators.required
        ],
        mask: null,
        functions: {
          clickMatIconDelete: null
        },
        deleteIcon: true,
        class: 'inputs-form imovel-cep-icone inputs-icones-condominio fonts-sizes col-xl-2',
        matSpinner: {
          enabled: false,
          diameter: 20
        },
        matError: {
          enabled: true,
          errosConfig: [
            {
              hasError: 'required',
              message: 'Insira um CEP.'
            }
          ]
        },
      },
      imovelUF: {
        title: 'UF',
        type: 'mat-select',
        formControlName: 'imovelUF',
        options: null,
        valueDefault: null,
        validators: Validators.required,
        matError: {
          enabled: true,
          errosConfig: [
            {
              hasError: 'required',
              message: 'Selecione um UF.'
            }
          ]
        },
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-1',
      },
      imovelCidade: {
        title: 'Cidade',
        type: 'text',
        formControlName: 'imovelCidade',
        valueDefault: null,
        validators: Validators.required,
        mask: null,
        matError: {
          enabled: true,
          errosConfig: [
            {
              hasError: 'required',
              message: 'Insira uma Cidade.'
            }
          ]
        },
        functions: null,
        class: 'inputs-form fonts-sizes col-xl-4',
      },
      imovelBairro: {
        title: 'Bairro',
        type: 'text',
        formControlName: 'imovelBairro',
        valueDefault: null,
        validators: Validators.required,
        matError: {
          enabled: true,
          errosConfig: [
            {
              hasError: 'required',
              message: 'Insira um Bairro.'
            }
          ]
        },
        mask: null,
        functions: null,
        class: 'inputs-form fonts-sizes col-xl-5',
      },
      imovelLogradouro: {
        title: 'Lougradouro',
        type: 'text',
        formControlName: 'imovelLogradouro',
        valueDefault: null,
        validators: Validators.required,
        mask: null,
        matError: {
          enabled: true,
          errosConfig: [
            {
              hasError: 'required',
              message: 'Insira o Logradouro.'
            }
          ]
        },
        functions: null,
        class: 'inputs-form fonts-sizes col-xl-6',
      },
      imovelNumero: {
        title: 'Número',
        type: 'text',
        formControlName: 'imovelNumero',
        valueDefault: null,
        validators: [Validators.required, Validators.pattern('[0-9]{1,6}'), Validators.min(1)],
        mask: null,
        matError: {
          enabled: true,
          errosConfig: [
            {
              hasError: 'required',
              message: 'Insira um Número.'
            }
          ]
        },
        functions: null,
        class: 'inputs-form fonts-sizes col-xl-1',
      },
      imovelComplemento: {
        title: 'Complemento',
        type: 'text',
        formControlName: 'imovelComplemento',
        valueDefault: '',
        validators: null,
        mask: null,
        functions: null,
        class: 'inputs-form fonts-sizes col-xl-5',
      },
      condConstituidoLegalmente: {
        title: 'Cond. Constituído Legalmente?',
        type: 'mat-select',
        formControlName: 'condConstituidoLegalmente',
        options: null,
        valueDefault: true,
        validators: [Validators.required],
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      imovelAtividade: {
        title: 'Tipo de Condomínio',
        type: 'mat-select',
        formControlName: 'imovelAtividade',
        options: null,
        valueDefault: null,
        matError: {
          enabled: true,
          errosConfig: [
            {
              hasError: 'required',
              message: 'Selecione uma Opção.'
            }
          ]
        },
        validators: Validators.required,
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-4',
      },
      anoFundacao: {
        title: 'Ano de Fundação',
        type: 'text',
        formControlName: 'anoFundacao',
        valueDefault: null,
        validators: [Validators.required, Validators.pattern('[0-9]{4}'), Validators.min(1600), Validators.max(new Date().getFullYear())],
        mask: null,
        functions: null,
        matError: {
          enabled: true,
          errosConfig: [
            {
              hasError: 'required',
              message: 'Insira um Ano.'
            }
          ]
        },
        class: 'inputs-form fonts-sizes col-xl-2',
      },
      qtdVagasGaragem: {
        title: 'Qtd de Vagas de Garagem',
        type: 'mat-select',
        formControlName: 'qtdVagasGaragem',
        options: null,
        valueDefault: 0,
        validators: [Validators.required],
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      estruturaCondominio: {
        title: 'Estrutura',
        type: 'mat-select',
        formControlName: 'estruturaCondominio',
        options: null,
        valueDefault: 1,
        validators: Validators.required,
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      qtdElevadores: {
        title: 'Qtd. de Elevadores',
        type: 'mat-select',
        formControlName: 'qtdElevadores',
        options: null,
        valueDefault: null,
        validators: [Validators.required],
        mask: null,
        functions: null,
        matError: {
          enabled: true,
          errosConfig: [
            {
              hasError: 'required',
              message: 'Selecione uma Opção.'
            }
          ]
        },
        class: 'inputs-form fonts-sizes col-xl-2',
      },
      modalidade: {
        title: 'Modalidade',
        type: 'mat-select',
        formControlName: 'modalidade',
        options: null,
        valueDefault: 1,
        validators: Validators.required,
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-2',
      },
      sisProtecaoIncendRoubo: {
        title: 'Sistemas de Proteção',
        type: 'mat-select-multiple',
        formControlName: 'sisProtecaoIncendRoubo',
        options: null,
        valueDefault: [1],
        validators: null,
        mask: null,
        class: 'inputs-form fonts-sizes col-xl-3',
      },
      buttonSubmit: {
        title: 'SUBMIT',
        type: 'button',
        formControlName: 'buttonSubmit',
        valueDefault: 'J',
        validators: null,
        mask: null,
        functions: null,
        class: 'd-none',
        id: 'button-submit-configuracoes'
      }
    };
  }

  public static get estruturaCondominio() {
    return [
      { value: 1, viewValue: 'Vertical' },
      { value: 2, viewValue: 'Horizontal' },
    ]
  }
  public static get modalidade() {
    return [
      { value: 1, viewValue: 'Tradicional' },
      { value: 2, viewValue: 'Ampla' },
    ]
  }
  public static get tpGuardaTerceirizada() {
    return [
      { value: 0, viewValue: 'Não contratar' },
      { value: 1, viewValue: 'Compreensiva' },
      { value: 2, viewValue: 'Incêndio e roubo' },
    ]
  }
  public static get vidaGrupo() {
    return [
      { value: 0, viewValue: 'Não contratada' },
      { value: 1, viewValue: 'Morte/Ipa' },
      { value: 2, viewValue: 'Morte/IPA/IEA' },
      { value: 3, viewValue: 'Morte/IPA/IEA/IFPD' },
    ]
  }
  public static get condConstituidoLegalmente() {
    return [
      { value: true, viewValue: 'Sim' },
      { value: false, viewValue: 'Não' },
    ]
  }
  public static get assist24hs() {
    return [
      { value: 0, viewValue: 'Não' },
      { value: 1, viewValue: 'Básica' },
      { value: 2, viewValue: 'Normal' },
      { value: 3, viewValue: 'Completa' },
    ]
  }
  public static get tipoSeguro() {
    return [
      { value: 1, viewValue: 'Novo' },
      { value: 2, viewValue: 'Renovação' },
    ]
  }
  public static get qtdVagasGaragem() {

    return [
      { value: 0, viewValue: 'O prédio não possui garagem' },
      { value: 1, viewValue: 'Até 25 vagas' },
      { value: 2, viewValue: 'Até 50 vagas' },
      { value: 3, viewValue: 'Até 100 vagas' },
      { value: 4, viewValue: 'Mais de 100 vagas' },
    ]
  }

  public static get sisProtecaoIncendRoubo() {
    return [
      // { value: 0, viewValue: 'Nenhum' },
      { value: 1, viewValue: 'Extintores' },
      { value: 2, viewValue: 'Hidrantes' },
      { value: 3, viewValue: 'Sprinklers' },
      { value: 4, viewValue: 'Câmeras' },
      { value: 5, viewValue: 'Alarme' },
      { value: 6, viewValue: 'Portaria 24h' },
    ]
  }

  public static get imovelAtividade() {
    return [
      { value: 1, viewValue: 'Exclusivamente Residencial' },
      { value: 2, viewValue: 'Resid. - Até 15% da área ocupada por comércio' },
      { value: 5, viewValue: 'Misto' },
      { value: 4, viewValue: 'Comercial' },
      { value: 6, viewValue: 'Escritórios/Consultórios' },
      { value: 8, viewValue: 'Consultórios e escritórios com comércio' },
      // { value: 7, viewValue: 'Edifício Garagem' },
      { value: 3, viewValue: 'Residencial com escritórios/consultórios' },
      // { value: 9, viewValue: 'Flat (Exceto Hoteis e moteis)' },
      // { value: 10, viewValue: 'Flat/Hotel' },
      // { value: 11, viewValue: 'Flat/Hotel Com comércio' },
      // { value: 12, viewValue: 'Shopping Center' },
    ]
  }

  public static get qtdElevadores() {

    return [
      { value: 0, viewValue: 'Não possuí' },
      { value: 1, viewValue: '1' },
      { value: 2, viewValue: '2' },
      { value: 3, viewValue: '3' },
      { value: 4, viewValue: '4' },
    ]
  }

  public static get seguradoraAnterior() {
    return [
      { value: 1, viewValue: 'Allianz' },
      { value: 2, viewValue: 'Bradesco' },
    ]

  }
}
